import React, { useEffect, useRef, useState } from 'react'
import CommonSelect from './commonSelect';
import {  Purpose } from '../../../../core/data/json/apmc';
// import { useSubmit } from 'react-router'
import { useSelector } from 'react-redux';
import { getApmcPurposes, submitAnnexureThree } from '../../../auth/services/privateapicalling';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';


interface APMCp3Props {
  onBack: () => void;
  formData: any;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement> , documentName: string,index?:any) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  assistanceDetails: {
    dateField: string;
    scheme2: string;
    purpose2: string;
    sanctionedAmount: string;
    assistanceReceived: string;
    totalExpenditure: string;
    shortfall: string;
    workCompletionDetails: any;
    contributionRatio: string;
    
  }[];
  setAssistanceDetails: React.Dispatch<React.SetStateAction<{
    dateField: string;
    scheme2: string;
    purpose2: string;
    sanctionedAmount: string;
    assistanceReceived: string;
    totalExpenditure: string;
    shortfall: string;
    workCompletionDetails: any;
    contributionRatio: string;
  }[]>>;
  userDetail: any;
  purpose?: any;
  selectedSchemeDetails?: any;
  applicationId?: string;
  couchID?: string;
  token: string;
  schemeIdd: string;
}



const APMCp3 = ({
  onBack,
  formData,
  handleFileChange,
  handleInputChange,
  assistanceDetails,
  setAssistanceDetails,
  userDetail,
  purpose,
  applicationId,
  selectedSchemeDetails,
  couchID,
  token,
  schemeIdd,
}: APMCp3Props) => {
  
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Add state for file URLs (for preview)
  const [fileUrls, setFileUrls] = useState<{ [key: string]: string }>({});
  const navigate = useNavigate();
 const scheme =[{
  label: formData?.scheme,
  value: formData?.scheme
 }]

 const[purposes, setPurposes] = useState<any[]>([]);
  const [touched, setTouched] = useState<{ [key: string]: boolean }>({});


  // Refs for static fields
  const refs = {
    isLandOwnedByMarketingCommitee: useRef<HTMLInputElement>(null),
    hasAssistanceApproved: useRef<HTMLInputElement>(null),
    isMarktingCommitteeLocatedInGeneral: useRef<HTMLInputElement>(null),
    marktingCommitteeLocatedInGeneral: useRef<HTMLInputElement>(null),
    isMarktingCommFinanciallyCapableOfExpense: useRef<HTMLInputElement>(null),
    marktingCommFinanciallyCapableOfExpense: useRef<HTMLInputElement>(null),
    incExpenditureForLast3Yrs: useRef<HTMLInputElement>(null),
    auditIncExpenditureForLast3Yrs: useRef<HTMLInputElement>(null),
    existingFarmerFacilities: useRef<HTMLInputElement>(null),
    marketCessIncome5YrsLast: useRef<HTMLInputElement>(null),
    marketCessIncome5YrsNext: useRef<HTMLInputElement>(null),
    availingAssistance: useRef<HTMLInputElement>(null),
  };


  // Dynamic refs for assistanceDetails blocks (fix: useRef array, not hook in map)
  const assistanceRefs = useRef<Array<{
    dateField: React.RefObject<HTMLInputElement>,
    scheme2: React.RefObject<HTMLDivElement>,
    purpose2: React.RefObject<HTMLDivElement>,
    sanctionedAmount: React.RefObject<HTMLInputElement>,
    assistanceReceived: React.RefObject<HTMLInputElement>,
    totalExpenditure: React.RefObject<HTMLInputElement>,
    shortfall: React.RefObject<HTMLInputElement>,
    workCompletionDetails: React.RefObject<HTMLInputElement>,
    contributionRatio: React.RefObject<HTMLInputElement>,
  }>>([]);

  // Ensure refs array matches assistanceDetails length
  while (assistanceRefs.current.length < assistanceDetails.length) {
    assistanceRefs.current.push({
      dateField: React.createRef(),
      scheme2: React.createRef(),
      purpose2: React.createRef(),
      sanctionedAmount: React.createRef(),
      assistanceReceived: React.createRef(),
      totalExpenditure: React.createRef(),
      shortfall: React.createRef(),
      workCompletionDetails: React.createRef(),
      contributionRatio: React.createRef(),
    });
  }
  while (assistanceRefs.current.length > assistanceDetails.length) {
    assistanceRefs.current.pop();
  }

  // const userDetail = useSelector((state:any)=>state.auth.userDetails)

const getpurpose=async(scheme)=>{
  try{
        const resp= await getApmcPurposes(scheme)
    const rawPurposes = resp?.data.map((item: any) => ({
      label: item.subName,
      value: item.subName,
    }));
    setPurposes(rawPurposes);
  
    
    // setPurposes(rawPurposes)
      }catch(error){
   
      }
}
  

//---------------------------------- Validation logic for each field----------------------------------
  const validate = () => {
    const errors: { [key: string]: string } = {};
    if (!formData.isLandOwnedByMarketingCommitee) errors.isLandOwnedByMarketingCommitee = "Land ownership proof is required.";
    if (!formData.hasAssistanceApproved) errors.hasAssistanceApproved = "Please select Yes or No.";
    if (!formData.isMarktingCommitteeLocatedInGeneral) errors.isMarktingCommitteeLocatedInGeneral = "Please select Yes or No.";
    if (formData.isMarktingCommitteeLocatedInGeneral==="yes"&& !formData.marktingCommitteeLocatedInGeneral) errors.marktingCommitteeLocatedInGeneral = "Area category certificate is required.";
    // if (!formData.isMarktingCommFinanciallyCapableOfExpense) errors.isMarktingCommFinanciallyCapableOfExpense = "Please select Yes or No.";
    if (!formData.marktingCommFinanciallyCapableOfExpense) errors.marktingCommFinanciallyCapableOfExpense = "Financial capacity statement is required.";
    if (!formData.incExpenditureForLast3Yrs) errors.incExpenditureForLast3Yrs = "Financial statement is required.";
    if (!formData.auditIncExpenditureForLast3Yrs) errors.auditIncExpenditureForLast3Yrs = "Audited statements are required.";
    if (!formData.existingFarmerFacilities) errors.existingFarmerFacilities = "Farmer facilities list is required.";
    if (!formData.marketCessIncome5YrsLast) errors.marketCessIncome5YrsLast = "Document 19a is required.";
    if (!formData.marketCessIncome5YrsNext) errors.marketCessIncome5YrsNext = "Document 19b is required.";
    if (!formData.availingAssistance) errors.availingAssistance = "Availing Assistance is required.";

    if (formData.hasAssistanceApproved === "yes") {
      assistanceDetails.forEach((block, index) => {
        if (!block.dateField) {
          errors[`assistanceDetails[${index}].dateField`] = `Date is required for entry #${index + 1}`;
        }
        if (!block.scheme2) {
          errors[`assistanceDetails[${index}].scheme2`] = `Scheme is required for entry #${index + 1}`;
        }
        if (!block.purpose2) {
          errors[`assistanceDetails[${index}].purpose2`] = `Purpose is required for entry #${index + 1}`;
        }
        if (!block.sanctionedAmount) {
          errors[`assistanceDetails[${index}].sanctionedAmount`] = `Amount is required for entry #${index + 1}`;
        }
        if (!block.assistanceReceived) {
          errors[`assistanceDetails[${index}].assistanceReceived`] = `Assistance is required for entry #${index + 1}`;
        }
        if (!block.totalExpenditure) {
          errors[`assistanceDetails[${index}].totalExpenditure`] = `Expenditure is required for entry #${index + 1}`;
        }
        if (!block.shortfall) {
          errors[`assistanceDetails[${index}].shortfall`] = `Shortfall is required for entry #${index + 1}`;
        }
        if (!block.workCompletionDetails) {
          errors[`assistanceDetails[${index}].workCompletionDetails`] = `Work details is required for entry #${index + 1}`;
        }
        // if (!block.contributionRatio) {
        //   errors[`assistanceDetails[${index}].contributionRatio`] = `Contribution is required for entry #${index + 1}`;
        // }
      });
    }

    return errors;
  };

  const errors = validate();

//---------------------------------- Handle Select Changes----------------------------------
  


  //---------------------------------- Drop Down for 12 ----------------------------------

// ✅ Use props directly
// const assistanceBlocks = assistanceDetails;
// const setAssistanceDetails  = setAssistanceDetails;

type AssistanceField = 'dateField' | 'scheme2' | 'purpose2' | 'sanctionedAmount' | 'assistanceReceived' | 'totalExpenditure' |'shortfall' |'workCompletionDetails'|'contributionRatio';


// Add and remove for 12
const handleAssistanceChange = (
  index: number,
  field: AssistanceField,
  value: any
) => {
  if(value?.target?.files?.length>0){
    handleFileChange(value,field,index)

  }else{
  const updated = [...assistanceDetails ];
  updated[index][field] = value;
  setAssistanceDetails (updated);}
};


const addAssistanceBlock = () => {
  if (assistanceDetails .length < 6) {
    setAssistanceDetails ([
      ...assistanceDetails ,
      { dateField: "", scheme2: "", purpose2: "", sanctionedAmount: "",assistanceReceived:"", totalExpenditure:"" , shortfall:"", contributionRatio:"", workCompletionDetails:"" }
    ]);
  }
};

const removeAssistanceBlock = (index: number) => {
  const updated = assistanceDetails .filter((_, i) => i !== index);
  setAssistanceDetails (updated);
};
const buildAnnexureThreePayload = () => {
  return {
    
    isLandOwnedByMarketingCommitee: {
      data: formData.isLandOwnedByMarketingCommitee
        ? [{ docId: formData.isLandOwnedByMarketingCommitee.docId, documentName: "isLandOwnedByMarketingCommitee", fileName: formData?.isLandOwnedByMarketingCommitee?.fileName }]
        : []
    },
   hasAssistanceApproved : {
  data: [
    {
      value: formData.hasAssistanceApproved,
      fieldName: "isApproved"
    },
    ...(formData.hasAssistanceApproved === "yes"
      ? assistanceDetails.map((item, idx) => ({
          value: {
            date: item.dateField,
            scheme: item.scheme2,
            purpose: item.purpose2,
            amount: item.sanctionedAmount,
            assistance: item.assistanceReceived,
            expenditure: item.totalExpenditure,
            shortfall: item.shortfall,
            completion: item.workCompletionDetails,
           
          },
          fieldName: `details_${idx + 1}`
        }))
      : [])
  ]
},
    isMarktingCommitteeLocatedInGeneral: {
      data: [{
        value: formData.isMarktingCommitteeLocatedInGeneral,
        fieldName:"isApproved",
      },
        formData.isMarktingCommitteeLocatedInGeneral === "yes" ?
          {
            docId: formData.marktingCommitteeLocatedInGeneral.docId,
            documentName: "marktingCommitteeLocatedInGeneral",
            fileName: formData?.marktingCommitteeLocatedInGeneral?.fileName
          } : []
      ]
    },
    isMarktingCommFinanciallyCapableOfExpense: {
      data: [
       
          {
            docId: formData.marktingCommFinanciallyCapableOfExpense.docId,
            documentName: "marktingCommFinanciallyCapableOfExpense",
            fileName: formData?.marktingCommFinanciallyCapableOfExpense?.fileName
          } 
      ]
    },
    incExpenditureForLast3Yrs: {
      data: formData.incExpenditureForLast3Yrs
        ? [{ docId: formData.incExpenditureForLast3Yrs.docId, documentName: "incExpenditureForLast3Yrs", fileName: formData?.incExpenditureForLast3Yrs?.fileName }]
        : []
    },
    auditIncExpenditureForLast3Yrs: {
      data: formData.auditIncExpenditureForLast3Yrs
        ? [{ docId: formData.auditIncExpenditureForLast3Yrs.docId, documentName: "auditIncExpenditureForLast3Yrs", fileName: formData?.auditIncExpenditureForLast3Yrs?.fileName }]
        : []
    },

    existingFarmerFacilities: {
      data: formData.existingFarmerFacilities
        ? [{ docId: formData.existingFarmerFacilities.docId, documentName: "existingFarmerFacilities", fileName: formData?.existingFarmerFacilities?.fileName }]
        : []
    },
    marketCessIncome5YrsLast: {
      data: formData.marketCessIncome5YrsLast && formData.marketCessIncome5YrsLast.docId
        ? [{ docId: formData.marketCessIncome5YrsLast.docId, documentName: "marketCessIncome5YrsLast", fileName: formData?.marketCessIncome5YrsLast?.fileName },
          { docId: formData.marketCessIncome5YrsNext.docId, documentName: "marketCessIncome5YrsNext", fileName: formData?.marketCessIncome5YrsNext?.fileName }]
       
        : []
    },
    availingAssistance: {
      data: formData.availingAssistance && formData.availingAssistance.docId
        ? [{ docId: formData.availingAssistance.docId, documentName: "availingAssistance", fileName: formData?.availingAssistance?.fileName },
        ]
       
        : []
    },
  };
};
// ---------------------------------------SUBMIT---------------------------------------


const handleSubmit1 = async() => {
  try {
    // Run validation now to ensure latest error state
    const validationErrors = validate();
    if (Object.keys(validationErrors).length !== 0) {
      // Find the first error key
      const firstErrorKey = Object.keys(validationErrors)[0];
      // Check if it's a dynamic assistanceDetails error
      const match = firstErrorKey.match(/^assistanceDetails\[(\d+)\]\.(\w+)$/);
      if (match) {
        const idx = parseInt(match[1], 10);
        const field = match[2] as 'dateField' | 'scheme2' | 'purpose2' | 'sanctionedAmount'| 'assistanceReceived'| 'totalExpenditure' | 'shortfall'|'workCompletionDetails' | 'contributionRatio';
        if (assistanceRefs.current[idx] && assistanceRefs.current[idx][field] && assistanceRefs.current[idx][field].current) {
          if (field === 'scheme2' || field === 'purpose2') {
            assistanceRefs.current[idx][field].current.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            assistanceRefs.current[idx][field].current.focus();
          }
        }
      } else if (refs[firstErrorKey] && refs[firstErrorKey].current) {
        refs[firstErrorKey].current.focus();
      }
      return;
    }

    const formdata = {
      schemeId: String(schemeIdd),
      departmentId: userDetail?.Department_ID,
      districtId: userDetail?.Department?.district_id,
      couchId: couchID,
      annexureThree: buildAnnexureThreePayload(),
    };
    const res = await submitAnnexureThree(formdata, token, applicationId);
   

    if (res?.success) {
      setIsSubmitted(true);
       toast.success(res?.message || " Form submitted successfully",{position:"top-right"});
       setAssistanceDetails([{ dateField: "", scheme2: "", purpose2: "", sanctionedAmount: "", assistanceReceived:"", totalExpenditure:"", shortfall:"", workCompletionDetails:"", contributionRatio:"" }]);
      navigate("/menu");
    } else {
      toast.error(res?.message || "Failed to submit Annexure Three",{position:"top-right"});
    }
  } catch (error) {
    
  } finally {
    setIsSubmitted(false);
    
  }
};


useEffect(() => {
  getpurpose(formData?.scheme);
},[])

  return (
    <>
      <div className="page-wrapper ">
        <div className='d-flex flex-column text-nightblue align-items-center justify-content-center'>
          {/* <h1 >Application for Scheme - પરિશિષ્ટ-૧ (Annexure 1) </h1> */}
 
          <div id='table' className='w-100 border bg-white border-secondary rounded mb-5'>
            <div id='head' className='d-flex w-100  rounded-top border-bottom border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                <h4 className='col-1 p-2 justify-content-center d-flex align-items-center'>S.No.</h4>
                <h4 className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center  '>પ્રશ્ન(Field)</h4>
                <h4 className='col-5 p-2 justify-content-center d-flex align-items-center  '>જવાબ(Response)</h4>
               
            </div>

 
            <div className='d-flex  border-bottom border-secondary'>
                    <h4 className='col-1 justify-content-center d-flex align-items-center'>12.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary justify-content-center d-flex align-items-center '>
                        <p className='p-2'>જે હેતુ માટે સહાયની માંગણી કરવામાં આવી છે તે હેતુ માટે બજાર સમિતિની માલીકીની જમીન છે ? હા, તો તે અંગેના દસ્તાવેજોની નકલ. (Is the land for the proposed purpose owned by the Market Committee? (Attach ownership proof)).* </p>
                    </div>
                     <div className='col-5 d-flex flex-column align-items-center justify-content-center'>
                        <input
                          type="file"
                          className="form-control w-75"
                          onChange={(e)=>handleFileChange(e,"isLandOwnedByMarketingCommitee")}
                          name="isLandOwnedByMarketingCommitee"
                          accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                          id="uploadPlan"
                          ref={refs.isLandOwnedByMarketingCommitee}
                />
                 { formData?.isLandOwnedByMarketingCommitee&&<p className="small text-success">Uploaded :{formData?.isLandOwnedByMarketingCommitee?.fileName }</p>}
                        {errors && errors.isLandOwnedByMarketingCommitee && (
                          <span className="text-danger small">{errors.isLandOwnedByMarketingCommitee}</span>
                        )}
                    </div>
            </div>

            <div className='d-flex  border-bottom border-secondary '>
                <h4 className='col-1 justify-content-center d-flex align-items-center '>13.</h4>
                <div className='col-6 p-2 border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                    <p className='p-2'>આ યોજના હેઠળ અગાઉ સહાય મંજૂર થયેલ છે ? (Has assistance been approved under this scheme before?)*</p>
                </div>
                 {/* <div className='col-5 d-flex flex-column  gap-2 ps-5 align-items-start justify-content-center ms-4'>
                   
                </div> */}
                <div className='col-5 d-flex  flex-column align-items-center justify-content-center'>
                    <div className='d-flex  flex-column align-items-start justify-content-center w-75'>
                        <div className=' d-flex justify-start gap-2'>
                        <input type='radio' name='hasAssistanceApproved' value="yes" checked={formData.hasAssistanceApproved === "yes"} onChange={handleInputChange} ref={refs.hasAssistanceApproved} />Yes
                        <input type='radio' name='hasAssistanceApproved' value="no" checked={formData.hasAssistanceApproved === "no"} onChange={handleInputChange} />No
                        </div>
                        {errors && errors.hasAssistanceApproved && (
                          <span className="text-danger small">{errors.hasAssistanceApproved}</span>
                        )}
                    </div>
                </div>
                
            </div>
 
            {/* -------------------------------------------DROP DOWN FOR "YES" -----------------------------------------------*/}
            
            {formData.hasAssistanceApproved === "yes" && (
              <>
                {assistanceDetails.map((block, index) => (
                  <React.Fragment key={index}>
                    {/* 🔷 Heading */}
                    <div className="d-flex px-3 py-2 bg-light">
                      <strong>{['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'][index]} Detail</strong>
                    </div>

                    {/* 01. Date */}
                    <div className="d-flex border-top  border-secondary">
                      <h4 className="col-1"></h4>
                      <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                        <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">01.</h4>
                        <p className="col-10 p-2 d-flex align-items-center">ક્યારે (Date) *</p>
                      </div>
                      <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                        <input
                          type="date"
                          className="form-control w-75 m-2"
                          value={block.dateField}
                          onChange={(e) =>
                            handleAssistanceChange(index, "dateField", e.target.value)
                          }
                          max="2100-12-31"
                          ref={assistanceRefs.current[index]?.dateField}
                        />
                        {errors && errors[`assistanceDetails[${index}].dateField`] && (
                          <span className="text-danger small">{errors[`assistanceDetails[${index}].dateField`]}</span>
                        )}

                      </div>
                    </div>

                    {/* 02. Scheme / Purpose */}
                    <div className="d-flex border-bottom border-top border-secondary">
                      <h4 className="col-1"></h4>
                      <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                        <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">02.</h4>
                        <p className="col-10 p-2 d-flex align-items-center">યોજના, હેતુ (Scheme, Purpose) *</p>
                      </div>
                      <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                        <div ref={assistanceRefs.current[index]?.scheme2} style={{ width: '75%' }}>
                          <CommonSelect
                            className="select w-100 p-2 form-select"
                             options={
                           scheme
                          }
                            value={block.scheme2 ? scheme.find(opt => opt.value === block.scheme2) : undefined}
                            name="scheme2"
                            onChange={(option) =>
                              handleAssistanceChange(index, "scheme2", option?.value || "")
                            }
                            placeholder="Select Scheme"
                          />
                        </div>
                        {errors && errors[`assistanceDetails[${index}].scheme2`] && (
                          <span className="text-danger small">{errors[`assistanceDetails[${index}].scheme2`]}</span>
                        )}

                        <div ref={assistanceRefs.current[index]?.purpose2} style={{ width: '75%' }}>
                          <CommonSelect
                            className="select w-100 p-2 form-select"
                            options={purposes}
                            value={block.purpose2 ? purposes.find(opt => opt.value === block.purpose2) : undefined}
                            name="purpose2"
                            onChange={(option) =>
                              handleAssistanceChange(index, "purpose2", option?.value || "")
                            }
                            placeholder="Select Purpose"
                          />
                        </div>
                        {errors && errors[`assistanceDetails[${index}].purpose2`] && (
                          <span className="text-danger small">{errors[`assistanceDetails[${index}].purpose2`]}</span>
                        )}


                      </div>
                    </div>

                    {/* 03. Amount */}
                    <div className="d-flex border-bottom border-secondary">
                      <h4 className="col-1"></h4>
                      <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                        <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">03.</h4>
                        <p className="col-10 p-2 d-flex align-items-center">કુલ પ્રોજેકટની રકમ – Total Project Cost*</p>
                      </div>
                      <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                        <input
                          type="number"
                          inputMode="decimal"
                          min={0}
                          className="w-75 m-2 form-control"
                          placeholder="Enter Amount"
                          value={block.sanctionedAmount}
                          onChange={(e) =>
                            handleAssistanceChange(index, "sanctionedAmount", e.target.value)
                          }
                          ref={assistanceRefs.current[index]?.sanctionedAmount}
                        />
                        {errors && errors[`assistanceDetails[${index}].sanctionedAmount`] && (
                          <span className="text-danger small">{errors[`assistanceDetails[${index}].sanctionedAmount`]}</span>
                        )}

                      </div>
                    </div>

                    {/* 04. Assistance Received */}
                    <div className="d-flex border-bottom border-secondary">
                      <h4 className="col-1"></h4>
                      <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                        <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">04.</h4>
                        <p className="col-10 p-2 d-flex align-items-center">મળેલ સહાય – Assistance Received</p>
                      </div>
                      <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                        <input
                          type="number"
                          inputMode="decimal"
                          min={0}
                          className="w-75 m-2 form-control"
                          placeholder="Enter Value"
                          value={block.assistanceReceived}
                          onChange={(e) =>
                            handleAssistanceChange(index, "assistanceReceived", e.target.value)
                          }
                          ref={assistanceRefs.current[index]?.assistanceReceived}
                        />
                        {errors && errors[`assistanceDetails[${index}].assistanceReceived`] && (
                          <span className="text-danger small">{errors[`assistanceDetails[${index}].assistanceReceived`]}</span>
                        )}

                      </div>
                    </div>
                    {/* 05. Total Expenditure */}
                    <div className="d-flex border-bottom border-secondary">
                      <h4 className="col-1"></h4>
                      <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                        <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">05.</h4>
                        <p className="col-10 p-2 d-flex align-items-center">કુલ ખર્ચ – Total Expenditure</p>
                      </div>
                      <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                        <input
                          type="number"
                          inputMode="decimal"
                          min={0}
                          className="w-75 m-2 form-control"
                          placeholder="Enter Value"
                          value={block.totalExpenditure}
                          onChange={(e) =>
                            handleAssistanceChange(index, "totalExpenditure", e.target.value)
                          }
                          ref={assistanceRefs.current[index]?.totalExpenditure}
                        />
                        {errors && errors[`assistanceDetails[${index}].totalExpenditure`] && (
                          <span className="text-danger small">{errors[`assistanceDetails[${index}].totalExpenditure`]}</span>
                        )}

                      </div>
                    </div>
                    {/* 06. Excess/Shortfall */}
                    <div className="d-flex border-bottom border-secondary">
                      <h4 className="col-1"></h4>
                      <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                        <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">06.</h4>
                        <p className="col-10 p-2 d-flex align-items-center">વધ / ધટ – Excess / Shortfall</p>
                      </div>
                      <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                        <input
                          type="number"
                          inputMode="decimal"
                          min={0}
                          className="w-75 m-2 form-control"
                          placeholder="Enter Value"
                          value={block.shortfall}
                          onChange={(e) =>
                            handleAssistanceChange(index, "shortfall", e.target.value)
                          }
                          ref={assistanceRefs.current[index]?.shortfall}
                        />
                        {errors && errors[`assistanceDetails[${index}].shortfall`] && (
                          <span className="text-danger small">{errors[`assistanceDetails[${index}].shortfall`]}</span>
                        )}

                      </div>
                    </div>

                    {/* 07. Work Completion */}
                    <div className="d-flex border-bottom border-secondary">
                      <h4 className="col-1"></h4>
                      <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                        <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">07.</h4>
                        <p className="col-10 p-2 d-flex align-items-center">કામ પુર્ણ થયાની વિગતો – Details of Work Completion</p>
                      </div>
                      <div className="col-5 d-flex flex-column align-items-center justify-content-center my-2">
                        <input 
                          className='form-control w-75' 
                          type='file' 
                          onChange={(e) =>
                            handleAssistanceChange(index, "workCompletionDetails", e)
                          }
                          name="workCompletionDetails"   
                          accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"   
                          id='uploadPlan'
                          ref={assistanceRefs.current[index]?.workCompletionDetails}
                  />
                   { assistanceDetails[index]?.workCompletionDetails&&<p className="small text-success">Uploaded :{assistanceDetails[index]?.workCompletionDetails?.fileName }</p>}
                        {errors && errors[`assistanceDetails[${index}].workCompletionDetails`] && (
                          <span className="text-danger small">{errors[`assistanceDetails[${index}].workCompletionDetails`]}</span>
                        )}

                      </div>
                    </div>

                    {/* 08. Share Ratio */}
                    {/* <div className="d-flex border-bottom border-secondary">
                      <h4 className="col-1"></h4>
                      <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                        <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">08.</h4>
                        <p className="col-10 p-2 d-flex align-items-center">શેરો – Share (or Contribution/Ratio, depending on context)</p>
                      </div>
                      <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                        <input
                          type="text"
                          className="w-75 m-2 form-control"
                          placeholder="Enter Value"
                          value={block.contributionRatio}
                          onChange={(e) =>
                            handleAssistanceChange(index, "contributionRatio", e.target.value)
                          }
                          ref={assistanceRefs.current[index]?.contributionRatio}
                        />
                        {errors && errors[`assistanceDetails[${index}].contributionRatio`] && (
                          <span className="text-danger small">{errors[`assistanceDetails[${index}].contributionRatio`]}</span>
                        )}

                      </div>
                    </div> */}
                    <div className="d-flex border-bottom border-secondary px-3 py-2 justify-content-end gap-3">
                      {/* ➕ Add More (only on last block, max 6) */}
                      {index === assistanceDetails .length - 1 && assistanceDetails .length < 6 && (
                        <button
                          className="btn text-info d-flex align-items-center gap-2"
                          style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 'none' }}
                          onClick={addAssistanceBlock}
                        >
                          <i className="feather feather-plus-circle"></i> Add More
                        </button>
                      )}

                      {/* ➖ Remove (show for all blocks if total > 1) */}
                      {assistanceDetails .length > 1 && (
                        <button
                          className="btn text-danger d-flex align-items-center gap-2"
                          style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 'none' }}
                          onClick={() => removeAssistanceBlock(index)}
                        >
                          <i className="feather feather-trash"></i> Remove
                        </button>
                      )}
                    </div>



                  </React.Fragment>
                ))}
              </>
            )}
 
            <div className='d-flex border-bottom border-secondary'>
                <h4 className='col-1 justify-content-center d-flex align-items-center '>14.</h4>
                <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                    <p className='p-2'>
                        બજાર સમિતિ સામાન્ય વિસ્તાર કે આદિજાતિ વિસ્તારમાં આવેલી છે ?તેવી વિગત સામેલ છે ? તેની નકલ જિલ્લા રજિસ્ટ્રારશ્રીનુ પ્રમાણપત્ર (Whether the Market Committee is located in a general or tribal area? (Certificate from District Registrar)).*
                </p>
 
                </div>
               
                <div className='col-5 d-flex  flex-column align-items-center justify-content-center'>
                    <div className='d-flex gap-1 flex-column align-items-start justify-content-center w-75'>
                        <div className=' d-flex justify-start gap-2'>
                            <input type='radio' name='isMarktingCommitteeLocatedInGeneral' value="yes" checked={formData.isMarktingCommitteeLocatedInGeneral === "yes"} onChange={handleInputChange} />Yes
                            <input type='radio' name='isMarktingCommitteeLocatedInGeneral' value="no" checked={formData.isMarktingCommitteeLocatedInGeneral === "no"} onChange={handleInputChange} />No
                        </div>
                        {errors && errors.isMarktingCommitteeLocatedInGeneral && (
                          <span className="text-danger small">{errors.isMarktingCommitteeLocatedInGeneral}</span>
                        )}
                        <input 
                          className='form-control w-100' 
                          type='file' 
                          onChange={(e)=>handleFileChange(e,"marktingCommitteeLocatedInGeneral")}
                          name="marktingCommitteeLocatedInGeneral"   
                          accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"   
                          id='uploadPlan'
                          disabled={formData.isMarktingCommitteeLocatedInGeneral !== "yes"}
                          ref={refs.marktingCommitteeLocatedInGeneral}
                  />
                   { formData?.marktingCommitteeLocatedInGeneral&&<p className="small text-success">Uploaded :{formData?.marktingCommitteeLocatedInGeneral?.fileName }</p>}
                        {errors && errors.marktingCommitteeLocatedInGeneral && (
                          <span className="text-danger small">{errors.marktingCommitteeLocatedInGeneral}</span>
                        )}
                    </div>
                </div>
            </div>
 

            <div className='d-flex  border-bottom border-secondary'>
                <h4 className='col-1 justify-content-center d-flex align-items-center  '>15.</h4>
                <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                     <p className='p-2'>્રોજેકટ પૂર્ણ કરવા સહાય ઉપરાંતની રકમનો ખર્ચ કરવા માટે બજાર સમિતિ સક્ષમ છે ? તે ખર્ચ બજાર સમિતિ કેવી રીતે મેળવશે, તે અંગેની વિગતો સામેલ છે ? તેની નકલ (Is the Market Committee financially capable of bearing expenses beyond the assistance amount? Attach detailed explanation).*</p>
 
                </div>
               
                <div className='col-5 d-flex  flex-column align-items-center justify-content-center'>
                    <div className='d-flex gap-1 flex-column align-items-start justify-content-center w-75'>
                        {/* <div className=' d-flex justify-start gap-2'>
                            <input type='radio' name='isMarktingCommFinanciallyCapableOfExpense' value="yes" checked={formData.isMarktingCommFinanciallyCapableOfExpense === "yes"} onChange={handleInputChange} />Yes
                            <input type='radio' name='isMarktingCommFinanciallyCapableOfExpense' value="no" checked={formData.isMarktingCommFinanciallyCapableOfExpense === "no"} onChange={handleInputChange} />No
                        </div>
                        {errors && errors.isMarktingCommFinanciallyCapableOfExpense && (
                          <span className="text-danger small">{errors.isMarktingCommFinanciallyCapableOfExpense}</span>
                        )} */}
                        <input 
                          className='form-control w-100' 
                          type='file' 
                          onChange={(e)=>handleFileChange(e,"marktingCommFinanciallyCapableOfExpense")} 
                          name="marktingCommFinanciallyCapableOfExpense"   
                          accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"   
                          id='uploadPlan'
                         
                          ref={refs.marktingCommFinanciallyCapableOfExpense}
                  />
                   { formData?.marktingCommFinanciallyCapableOfExpense&&<p className="small text-success">Uploaded :{formData?.marktingCommFinanciallyCapableOfExpense?.fileName }</p>}
                        {errors && errors.marktingCommFinanciallyCapableOfExpense && (
                          <span className="text-danger small">{errors.marktingCommFinanciallyCapableOfExpense}</span>
                        )}
                    </div>
                </div>
            </div>
 

            <div className='d-flex  border-bottom border-secondary'>
                <h4 className='col-1 justify-content-center d-flex align-items-center '>16.</h4>
                <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                    <p className='p-2'>
                        છેલ્લા ત્રણ વર્ષના આવક, ખર્ચ અને બચતની વિગત દર્શાવતું પત્રક સામેલ છે ? તેની નકલ (Income, expenditure, and savings statement for last 3 years).*
                </p>
                </div>
                 <div className='col-5 d-flex flex-column align-items-center justify-content-center'>
                    <input 
                      type="file" 
                      className="form-control w-75" 
                      onChange={(e)=>handleFileChange(e,"incExpenditureForLast3Yrs")} 
                      name="incExpenditureForLast3Yrs"   
                      accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                      id="uploadPlan"  
                      ref={refs.incExpenditureForLast3Yrs}
                />
                 { formData?.incExpenditureForLast3Yrs&&<p className="small text-success">Uploaded :{formData?.incExpenditureForLast3Yrs?.fileName }</p>}
                    {errors && errors.incExpenditureForLast3Yrs && (
                      <span className="text-danger small">{errors.incExpenditureForLast3Yrs}</span>
                    )}
                </div>
            </div>
 
 
            <div className='d-flex  border-bottom border-secondary'>
                <h4 className='col-1 justify-content-center d-flex align-items-center '>17.</h4>
                <div className='col-6 p-2   border-start border-end border-secondary justify-content-center d-flex align-items-center   ' >
                    <p className='p-2'>
                    છેલ્લા ત્રણ વર્ષના આવક-જાવકના સરવૈયાની ઓડીટેડ પ્રમાણિત નકલસામેલ છે ? તેની નકલ. (Audited income-expenditure statements for last 3 years).*                
                </p>
                </div>
                 <div className='col-5 d-flex flex-column align-items-center justify-content-center'>
                    <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"auditIncExpenditureForLast3Yrs")} name="auditIncExpenditureForLast3Yrs"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.auditIncExpenditureForLast3Yrs}  />
                     { formData?.auditIncExpenditureForLast3Yrs&&<p className="small text-success">Uploaded :{formData?.auditIncExpenditureForLast3Yrs?.fileName }</p>}
                {errors && errors.auditIncExpenditureForLast3Yrs && (
                      <span className="text-danger small">{errors.auditIncExpenditureForLast3Yrs}</span>
                    )}
                </div>
            </div>
 
 
            <div className='d-flex  border-bottom border-secondary '>
                <h4 className='col-1 justify-content-center d-flex align-items-center '>18.</h4>
                <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center   '>
                    <p className='p-2'>
                        બજાર સમિતિ પાસે ખેડૂતલક્ષી કઇ કઇ સુવિધાઓ હાલ ઉપલબ્ધ છે, તેનું પત્રકસામેલ છે ? તેની નકલ. (List of existing farmer-oriented facilities available at APMC).*
                </p>
                </div>
                 <div className='col-5 d-flex flex-column align-items-center justify-content-center'>
                    <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"existingFarmerFacilities")} name="existingFarmerFacilities"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.existingFarmerFacilities}  />
                     { formData?.existingFarmerFacilities&&<p className="small text-success">Uploaded :{formData?.existingFarmerFacilities?.fileName }</p>}
                {errors && errors.existingFarmerFacilities && (
                      <span className="text-danger small">{errors.existingFarmerFacilities}</span>
                    )}
                </div>
            </div>
 
 
            <div className='d-flex border-bottom border-secondary'>
                <h4 className='col-1  justify-content-center d-flex align-items-center '>19.</h4>
                <div className='col-6 p-2  border-start border-end border-secondary  justify-content-center d-flex align-items-center   '>
                    <p className='p-2'>
                    છેલ્લા પાંચ વર્ષમાં નિયંત્રણમાં લીધેલ જણસીઓની માર્કેટ શેષ ફીની વિગત દર્શાવતું પત્રક તથા આગામી પાંચ વર્ષમાં માર્કેટ શેષ ફીની થનાર આવકની વિગત દર્શાવતું પત્રકસામેલ છે ? તેની નકલ. (Details of market cess income from seized goods in the last 5 years and projected income for the next 5 years).*                 
                </p>
                </div>
                 <div className='col-5 d-flex gap-2 flex-column  align-items-center justify-content-center'>
                    <input className='form-control w-75' type='file' onChange={(e)=>handleFileChange(e,"marketCessIncome5YrsLast")} name="marketCessIncome5YrsLast"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"   id='upload doc 1' ref={refs.marketCessIncome5YrsLast}></input>
                     { formData?.marketCessIncome5YrsLast&&<p className="small text-success">Uploaded :{formData?.marketCessIncome5YrsLast?.fileName }</p>}
                {errors && errors.marketCessIncome5YrsLast && (
                      <span className="text-danger small">{errors.marketCessIncome5YrsLast}</span>
                    )}
                    <input className='form-control w-75' type='file' onChange={(e)=>handleFileChange(e,"marketCessIncome5YrsNext")} name="marketCessIncome5YrsNext"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"   id='upload doc 2' ref={refs.marketCessIncome5YrsNext}></input>
                    { formData?.marketCessIncome5YrsNext&&<p className="small text-success">Uploaded :{formData?.marketCessIncome5YrsNext?.fileName }</p>}
                {errors && errors.marketCessIncome5YrsNext && (
                      <span className="text-danger small">{errors.marketCessIncome5YrsNext}</span>
                    )}
                </div>

            </div>
            <div className='d-flex  '>
                <h4 className='col-1  justify-content-center d-flex align-items-center '>20.</h4>
                <div className='col-6 p-2  border-start border-end border-secondary  justify-content-center d-flex align-items-center   '>
                    <p className='p-2'>
                    આ યોજના હેઠળ સહાય લેવા માટે બજાર સમિતિની મળેલ સામાન્ય સભાના ઠરાવની નકલ.(Copy of the Market Committee's General Body resolution regarding availing assistance under this scheme.)*                 
                </p>
                </div>
                 <div className='col-5 d-flex gap-2 flex-column align-items-center justify-content-center'>
                    <input className='form-control w-75' type='file' onChange={(e)=>handleFileChange(e,"availingAssistance")} name="availingAssistance"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"   id='upload doc 1' ref={refs.availingAssistance}></input>
                     { formData?.availingAssistance&&<p className="small text-success">Uploaded :{formData?.availingAssistance?.fileName }</p>}
                {errors && errors.availingAssistance && (
                      <span className="text-danger small">{errors.availingAssistance}</span>
                    )}
                    
                </div>

            </div>
           </div>
        </div>
        <div className="d-flex justify-content-end gap-2 mb-3">
          <button className="btn btn-secondary" onClick={onBack}>Back</button>
          <button className="btn btn-info" onClick={handleSubmit1}>Submit</button>
         
        </div>
      </div>
    </>
  )
}

export default APMCp3

